import React, { useState } from "react";
import PropTypes from "prop-types";
import { withStyles, Typography, Divider } from "@material-ui/core";
import t from "../../../../languages/pl";
import { themeTypeToBool, notArrayOrEmpty } from '../../../../utils/helpers';
import { StyledChip } from '../../../Common/CustomChip';
import ConfirmationDialog from "../../../Common/ConfirmationDialog";

const useStyles = theme => ({
    container: {
        margin: theme.spacing(1),
        width: "100%",
    },
    label: {
        marginLeft: theme.spacing(2),
        color: themeTypeToBool(theme.palette.type) ? "#808495" : "inherit"
    },
    divider: {
        background: themeTypeToBool(theme.palette.type) ? "#43425D" : "#43425D",
        height: 2,
        marginRight: theme.spacing(3)
    }
});

const existingGroups = (groups, deleteCallback) => {
    if(notArrayOrEmpty(groups))
        return <Typography variant="body1">{t.noDataInfo}</Typography>;
    return groups.map(group => {
        return (
            <StyledChip
                key={group.grupa_id}
                label={group.grupa}
                onDelete={deleteCallback.bind(this,group.grupa_id)}
            />
            );
    });
};

const Groups = props => {
    const { classes, title = "", groups = [], onDelete } = props;
    const [idToDelete, setIdToDelete] = useState(null);

    const handleGroupDelete = (id) => {
        onDelete && onDelete(id);
    };

    const handleGroupDeleteTry = (id) => {
        setIdToDelete(id);
    };

    return (
        <div className={classes.container}>
            <Typography
                variant="body2"
                className={classes.label}
            >
                {title}
            </Typography>
            <div className={classes.container}>
                {existingGroups(groups, handleGroupDeleteTry)}
                <Divider orientation="horizontal" variant="fullWidth" className={classes.divider} />
            </div>
            <ConfirmationDialog
                open={idToDelete !== null}
                onClose={() => setIdToDelete(null)}
                onSubmit={handleGroupDelete}
                id={idToDelete}
                action={t.deleteGroupConfirmation}
            />
        </div>
    );
};

export default withStyles(useStyles)(Groups);

Groups.propTypes = {
    classes: PropTypes.object,
    title: PropTypes.string,
    groups: PropTypes.array,
    onDelete: PropTypes.func
};